import React, { useEffect, useState } from 'react'
import './Timeline.css'
import { loanDetailList, fetchInterestRateMovement, setActivity } from '../../Global/Index';
import ClipLoader from 'react-spinners/ClipLoader';
import { ToastContainer, toast } from 'react-toastify';
import { useTheme } from '@emotion/react';


const override = {
    display: "block",
    margin: "10% auto",
    marginLeft: '50%'
};

export default function InterestRateMovement() {
    const [showMore, setShowMore] = useState(false);
    const colors = ['b-danger', 'b-primary', 'b-warning', 'b-success', 'b-info'];
    const [apidata, setApidata] = useState(null);
    const theme = useTheme()


    useEffect(() => {
        setActivity('Interest Rate Movement Page');

        const checkfun = async () => {
            try {
                const datas = await loanDetailList();
                handleLoanDetailResponse(datas);
            } catch (error) {
                console.log(`error in dashboard api of Interest Rate movement page ${error}`);
                toast.error('Something went wrong. Please try again later!');
            }
        };

        const handleLoanDetailResponse = (datas) => {
            if (datas.response.status === "503") {
                toast.warn(datas.response.message);
            } else if (datas.response.status === "200") {
                handleSuccessfulResponse(datas.response.data);
            } else if (datas.response.status === "500") {
                toast.error('Something went wrong. Please try again later!')
            } else if (datas.response.status === "419") {
                window.location.href = '/Session-Expired'
            } else if (datas.response.status == '401') {
                window.location.href = '/'
            }
        };

        const handleSuccessfulResponse = async (data) => {
            if (data && data.length > 0) {
                await fetchInterestRateMovement(data[0].loanStartDate, data[0].effectiveRateOfInterest)
                    .then(handleInterestRateMovementResponse)
                    .catch(handleInterestRateMovementError);
            } else {
                setApidata([]);
            }
        };

        const handleInterestRateMovementResponse = (datas) => {
            if (datas.response.status === "200") {
                setApidata(datas.response.rateofmovement);
            } else if (datas.response.status === "500") {
                toast.error('Something went wrong. Please try again later!')
            }
        };

        const handleInterestRateMovementError = (error) => {
            console.log(`error in fetching interest rate movement ${error}`);
            toast.error('Something went wrong. Please try again later!');
        };

        checkfun();
    }, []);
    const renderTimeline = (apidata) => {
        const limit = showMore ? apidata?.length : 5; // Show all or limit to 5
        return apidata?.slice(0, limit).map((event, index) => {
            const colorIndex = Math.floor(index / 2) % colors.length;
            const colorClass = colors[colorIndex];
            const isActive = index === 0 ? 'active' : '';
            return (
                <div className={`tl-item ${isActive}`} key={index + 1}>
                    <div className={`tl-dot ${colorClass}`}></div>
                    <div className="tl-content">
                        <div><b>{event.content}</b></div>
                        <div className="tl-date text-muted mt-1">{event.start_date} to {event.end_date}</div>
                    </div>
                </div>
            );
        }) || null; // Return null if apidata is undefined
    };

    return (

        <>
            <ToastContainer />
            <div className="maincontainer" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
                <h2>Interest Rate Changes</h2>
                <div>
                    <div className="page-content page-container" id="page-content">
                        <div className='mainsubcontainer' >
                            <div className="col-lg-6" >
                                {

                                    apidata != null ? <div className="timeline p-4 block mb-4">


                                        {
                                            apidata?.length > 0 && <div style={{ marginTop: '-2vh' }}>The Interest Rate movement of the loan is shown in chronological order</div>

                                        }

                                        {apidata?.length > 0 ? renderTimeline(apidata) : <div style={{ marginLeft: '40%', marginTop: '3%', color: 'red' }}>No Data Found</div>}

                                        {
                                            apidata?.length > 5 && <button
                                                className="btnn btn-primary mt-3"
                                                onClick={() => setShowMore(!showMore)}
                                            >
                                                {showMore ? 'Show Less' : 'Show More'}
                                            </button>
                                        }


                                        {
                                            apidata?.length > 0 && <div style={{ marginTop: '10vh' }}><b>Calculation shown here may change in the event of :- </b><br />
                                                <ul style={{ marginLeft: '3vw' }}>
                                                    <li>Interest rate/EMI is subject to change that may happen in the future</li>
                                                    {/* <li>Next reset date for account is on <strong>{apidata.nextemidate}</strong>  and the expected ROI on next reset is <strong>{apidata.expectedroi}% </strong> .This interest rate is subject to any change that may happen upone next reset date</li> */}
                                                </ul>
                                            </div>

                                        }
                                    </div> : <ClipLoader
                                        color={theme.palette.maincolor.light}
                                        loading={true}
                                        cssOverride={override}
                                        size={30}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                    />
                                }

                                {/* ................................................ */}
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </>

    )
}

